import { render, staticRenderFns } from "./PublishActions.vue?vue&type=template&id=681603c5&"
import script from "./PublishActions.vue?vue&type=script&lang=js&"
export * from "./PublishActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports